import { createContext } from 'react';

export const DeleteSubdomainModalContext = createContext({
  open: () => {},
});
